import { FormKeys } from './constants'
import { PrintType, charsPerLine, paperWidths } from '@/features/print/constants'
import { z } from 'zod'

export const schema = z.object({
    [FormKeys.Name]: z.string(),
    [FormKeys.CharsPerLine]: z.string().refine((arg) => charsPerLine.includes(parseInt(arg))),
    [FormKeys.PaperWidth]: z.string().refine((arg) => paperWidths.includes(parseInt(arg))),
    [FormKeys.PrintTypes]: z.array(z.nativeEnum(PrintType)),
})
